import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13502cc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 2,
  class: "errText"
}
const _hoisted_10 = {
  key: 0,
  class: "errText"
}
const _hoisted_11 = { key: 2 }

import { finishTask, taskVariables } from "@/api/home";
import { searchTestItems } from "@/api/setting_testItem";
import { getOrderInfo } from "@/api/order";
import message from "ant-design-vue/lib/message";
import { onMounted, reactive, toRefs } from "vue";
import { useRoute, useRouter } from "vue-router";
import { LocalStorageService } from "@/components/ts/localStorage";
import PickImage from "@/components/view/PickImage.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 't21',
  props: {
  id: String,
},
  setup(__props) {

const props = __props;




const columns = [
  {
    title: "病症",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "检出状态",
    dataIndex: "itemValue",
    key: "itemValue",
  },
  {
    title: "牙位",
    dataIndex: "toothIndex",
    key: "toothIndex",
  },
  {
    title: "操作",
    dataIndex: "operation",
    key: "operation",
  },
];

const data = reactive<{
  noTitleKey: string,
  activeKey: any[],
  dataSource: any[],
  roleField: any[],
  imageList: any[],
  tabListNoTitle: any[],
  opinion: string,
  xray: string,
  comment: string,
  complaints: string,
  spinning: boolean,
  faceImagePath: string,
  disableToothList: any[]
}>({
  noTitleKey: "S1",
  activeKey: [],
  dataSource: [],
  roleField: [],
  imageList: [],
  tabListNoTitle: [],
  opinion: '',
  xray: '',
  comment: '',
  complaints: '',
  spinning: false,
  faceImagePath: '',
  disableToothList: []
});
const {
  activeKey,
  dataSource,
  roleField,
} = toRefs(data);
const route = useRoute();
const router = useRouter();
onMounted(() => {
  console.log(route.query);
  init();
  if (route.query.taskCode == 'T46') {
    getOrderInfo(route.query.facialDetectionId).then((res: { faceImagePath: string; }) => {
      let sts = LocalStorageService.get('sts');
      let url = `https://${sts.bucket}.${sts.endpoint}/${res.faceImagePath}`
      data.faceImagePath = url
    })
  }
  if (route.query.oralDetectionResultItemList) {
    data.opinion = route.query.opinion as string
    data.complaints = route.query.complaints as string
    data.comment = route.query.comment as string
  }
});

const init = () => {
  let option = {
    page: {
      currPage: 1,
      pageSize: 1000,
    },
    isvalid: route.query.taskCode == 'T46' ? 1 : 0
  };
  searchTestItems(option).then((res: any) => {
    console.log(res.data);
    if (res.data) {
      dataSource.value = res.data ? res.data : [];
      let list = route.query.oralDetectionResultItemList ? JSON.parse(route.query.oralDetectionResultItemList as string) : []
      dataSource.value.forEach(item => {
        item.children.forEach((it: any) => {
          if (it.maladyType == 1) {
            it.itemValue = it.items.split(',')[0]
          }
          if (list) {
            list.forEach((element: { itemId: any; itemValue: any; toothIndex: any; }) => {
              if (element.itemId == it.id) {
                it.itemValue = element.itemValue
                it.toothIndex = element.toothIndex
                if (it.definition == '缺失牙') {
                  data.disableToothList = it.toothIndex.split(',')
                }
              }
            })
          }
        })
      })
    }
  });
  console.log(route.query.oralDetectionOrderId);
};

const onEdit = (record: any) => {
  console.log(record);
  // record.itemValue = ''
  if (record.items.length > 0) {
    record.toothIndex = record.toothIndex && record.toothIndex.length > 0 ? record.toothIndex.split(',') : []
  }
  roleField.value[record.id] = true;
};

const onSave = (record: any) => {
  console.log(record);
  if (record.items.length > 0) {
    record.toothIndex = record.toothIndex && record.toothIndex.length > 0 ? record.toothIndex.join(',') : ''
  }
  roleField.value[record.id] = false;
};

const onToothCheck = (record: any) => {
  if (record.definition == '缺失牙') {
    data.disableToothList = record.toothIndex
  }
}

const arrayFilter = (arr1: any[], arr2: any[]) => {
  return arr2.filter((item: any) => !arr1.some((ele: any) => ele === item));
}
const checkIntersection = (arr1: any[], arr: any) => {
  let arr2: any[] = [];
  if (arr instanceof Array) {
    arr2 = arr;
  } else {
    arr2 = arr ? arr.split(',') : [];
  }
  let result = false;
  for (const item of arr1) {
    if (arr2.includes(item)) {
      result = true;
      break;
    }
  }
  return result;
}

const formatRoles = (record: any, type: number) => {
  if (type == 1) {
    record.itemValue = record.itemValue ? record.itemValue : "否";
    return record.itemValue;
  } else {
    record.itemValue = record.toothIndex ? "是" : "否";
    return record.toothIndex;
  }
};



const onSubmit = () => {
  data.spinning = true
  let oralDetectionResultItemList: any[] = [];
  let result = false;
  dataSource.value.forEach((it: any) => {
    it.children.forEach((item: any) => {
      let flag = item.definition == '缺失牙' ? false : checkIntersection(data.disableToothList, item.toothIndex);
      if (flag) {
        result = true;
        return;
      }
      if (item.toothIndex instanceof Array) {
        item.toothIndex = item.toothIndex.join(',')
      }
      oralDetectionResultItemList.push({
        itemId: item.id,
        itemValue: item.itemValue ? item.itemValue : "否",
        toothIndex: item.toothIndex ? item.toothIndex : '',
      });
    });
  });

  if (result) {
    message.error('牙齿选择错误');
    data.spinning = false
    return
  }

  let option = {
    processDefinitionId: route.query.processDefinitionId,
    processDefinitionKey: route.query.processDefinitionKey,
    processInstanceId: route.query.processInstanceId,
    runTimeTaskId: route.query.runTimeTaskId,
    taskCode: route.query.taskCode,
    params: {
      oralDetectionOrderId: route.query.oralDetectionOrderId,
      opinion: data.opinion,
      complaints: data.complaints,
      comment: data.comment,
      xray: data.xray,
      oralDetectionResultItemList,
    },
  };
  finishTask(option).then(() => {
    data.spinning = false
    message.success("操作成功");
    router.push({
      path: "/home",
    });
  }).catch(() => {
    data.spinning = false
  })
};

const onSaveData = () => {
  data.spinning = true
  console.log(dataSource.value);
  let oralDetectionResultItemList: any[] = [];
  dataSource.value.forEach((it: any) => {
    it.children.forEach((item: any) => {
      if (item.toothIndex instanceof Array) {
        item.toothIndex = item.toothIndex.join(',')
      }
      oralDetectionResultItemList.push({
        itemId: item.id,
        itemValue: item.itemValue ? item.itemValue : "否",
        toothIndex: item.toothIndex ? item.toothIndex : '',
      });
    });
  });
  let option = {
    processDefinitionId: route.query.processDefinitionId,
    processDefinitionKey: route.query.processDefinitionKey,
    processInstanceId: route.query.processInstanceId,
    runTimeTaskId: route.query.runTimeTaskId,
    taskCode: route.query.taskCode,
    params: {
      oralDetectionOrderId: route.query.oralDetectionOrderId,
      opinion: data.opinion,
      complaints: data.complaints,
      comment: data.comment,
      xray: data.xray,
      oralDetectionResultItemList: JSON.stringify(oralDetectionResultItemList),
    },
  };
  taskVariables(option).then(() => {
    data.spinning = false
    message.success("操作成功");
    router.push({
      path: "/home",
    });
  }).catch(() => {
    data.spinning = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_spin, {
      spinning: data.spinning
    }, {
      default: _withCtx(() => [
        (_unref(route).query.oralDetectionOrderId != null || props.id)
          ? (_openBlock(), _createBlock(PickImage, {
              key: 0,
              oralDetectionOrderId: _unref(route).query.oralDetectionOrderId || props.id
            }, null, 8, ["oralDetectionOrderId"]))
          : _createCommentVNode("", true),
        _hoisted_2,
        _withDirectives(_createVNode(_component_a_card, {
          title: "面部照",
          bordered: false,
          style: {"text-align":"left"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_space, { size: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_image, {
                  width: 200,
                  src: data.faceImagePath + 'Frontal.JPEG'
                }, null, 8, ["src"]),
                _createVNode(_component_a_image, {
                  width: 200,
                  src: data.faceImagePath + 'FrontalSmile.JPEG'
                }, null, 8, ["src"]),
                _createVNode(_component_a_image, {
                  width: 200,
                  src: data.faceImagePath + 'Profile.JPEG'
                }, null, 8, ["src"]),
                _createVNode(_component_a_image, {
                  width: 200,
                  src: data.faceImagePath + '45Profile.JPEG'
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _unref(route).query.taskCode == 'T46']
        ]),
        _createVNode(_component_a_card, {
          title: "病症列表",
          bordered: false,
          style: {"text-align":"left"}
        }, {
          extra: _withCtx(() => []),
          default: _withCtx(() => [
            _createVNode(_component_a_space, {
              size: 10,
              direction: "vertical",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: data.complaints,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data.complaints) = $event)),
                  placeholder: "主诉",
                  rows: 4
                }, null, 8, ["value"]),
                _createVNode(_component_a_collapse, {
                  activeKey: _unref(activeKey),
                  "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => (_isRef(activeKey) ? (activeKey).value = $event : null)),
                  accordion: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataSource), (item) => {
                      return (_openBlock(), _createBlock(_component_a_collapse_panel, {
                        key: item.id,
                        header: item.name
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_table, {
                            dataSource: item.children,
                            columns: columns,
                            pagination: false
                          }, {
                            bodyCell: _withCtx(({ column, record }) => [
                              (column.dataIndex === 'itemValue')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (record.maladyType == 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                          (_unref(roleField)[record.id])
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                (record.items.length > 0)
                                                  ? (_openBlock(), _createBlock(_component_a_select, {
                                                      key: 0,
                                                      ref_for: true,
                                                      ref: "select",
                                                      value: record.itemValue,
                                                      "onUpdate:value": ($event: any) => ((record.itemValue) = $event),
                                                      style: {"width":"120px"},
                                                      onChange: ($event: any) => (onSave(record))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.items.split(','), (item, index) => {
                                                          return (_openBlock(), _createBlock(_component_a_select_option, {
                                                            key: index,
                                                            value: item
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(item), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["value"]))
                                                        }), 128))
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["value", "onUpdate:value", "onChange"]))
                                                  : (_openBlock(), _createBlock(_component_a_input, {
                                                      key: 1,
                                                      value: record.itemValue,
                                                      "onUpdate:value": ($event: any) => ((record.itemValue) = $event),
                                                      style: {"width":"180px"}
                                                    }, null, 8, ["value", "onUpdate:value"]))
                                              ], 64))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode(_toDisplayString(formatRoles(record, 1)), 1)
                                              ], 64))
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(record.toothIndex ? "是" : "否"), 1))
                                  ], 64))
                                : _createCommentVNode("", true),
                              (column.dataIndex === 'toothIndex')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (record.maladyType == 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                          (_unref(roleField)[record.id])
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                (record.items.length > 0)
                                                  ? (_openBlock(), _createBlock(_component_a_select, {
                                                      key: 0,
                                                      ref_for: true,
                                                      ref: "select",
                                                      value: record.toothIndex,
                                                      "onUpdate:value": ($event: any) => ((record.toothIndex) = $event),
                                                      style: {"width":"120px"},
                                                      mode: "multiple",
                                                      onChange: ($event: any) => (onToothCheck(record))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arrayFilter(data.disableToothList, record.items.split(',')), (item, index) => {
                                                          return (_openBlock(), _createBlock(_component_a_select_option, {
                                                            key: index,
                                                            value: item
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(item), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["value"]))
                                                        }), 128))
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["value", "onUpdate:value", "onChange"]))
                                                  : (_openBlock(), _createBlock(_component_a_input, {
                                                      key: 1,
                                                      value: record.toothIndex,
                                                      "onUpdate:value": ($event: any) => ((record.toothIndex) = $event),
                                                      style: {"width":"180px"}
                                                    }, null, 8, ["value", "onUpdate:value"])),
                                                (checkIntersection(data.disableToothList, record.toothIndex) && record.definition != '缺失牙')
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, " 该牙齿是缺失牙请重新选择"))
                                                  : _createCommentVNode("", true)
                                              ], 64))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createElementVNode("p", null, _toDisplayString(formatRoles(record, 2)), 1),
                                                (checkIntersection(data.disableToothList, record.toothIndex) && record.definition != '缺失牙')
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, " 该牙齿是缺失牙请重新选择"))
                                                  : _createCommentVNode("", true)
                                              ], 64))
                                        ]))
                                  ], 64))
                                : _createCommentVNode("", true),
                              (column.dataIndex === 'operation')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    (data.roleField[record.id])
                                      ? (_openBlock(), _createBlock(_component_a_button, {
                                          key: 0,
                                          type: "link",
                                          onClick: ($event: any) => (onSave(record))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("保存")
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : (_openBlock(), _createBlock(_component_a_button, {
                                          key: 1,
                                          type: "link",
                                          onClick: ($event: any) => (onEdit(record))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("编辑")
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["dataSource"]),
                          (item.name == '口腔病史')
                            ? (_openBlock(), _createBlock(_component_a_textarea, {
                                key: 0,
                                value: data.comment,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((data.comment) = $event)),
                                placeholder: "口腔病史备注",
                                rows: 4
                              }, null, 8, ["value"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["header"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["activeKey"]),
                _createVNode(_component_a_textarea, {
                  value: data.opinion,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((data.opinion) = $event)),
                  placeholder: "请填写医嘱",
                  rows: 4
                }, null, 8, ["value"]),
                _createVNode(_component_a_space, { size: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, { onClick: onSaveData }, {
                      default: _withCtx(() => [
                        _createTextVNode("暂存")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, { onClick: onSubmit }, {
                      default: _withCtx(() => [
                        _createTextVNode("提交")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}
}

})